import React from "react";
import LoadingIndicator from "react-loading-indicator";

import * as SC from "./ContinueButton.styled";

const ContinueButton = ({
  id = "continue-button",
  onClick,
  isDisabled,
  isLoading,
  height,
  children,
  // Optional
  color = null,
  backgroundColor = null
}) => {
  return (
    <SC.Button
      onClick={onClick}
      disabled={isDisabled}
      id={id}
      height={height}
      color={color}
      backgroundColor={backgroundColor}
    >
      {isLoading ? <LoadingIndicator /> : children}
    </SC.Button>
  );
};

export default ContinueButton;
